import styles from './CircleCI.module.scss'
import Contact from '../pages/Contact'
import BestPractice from '../pages/BestPractice'
import Features from '../pages/Features'
import Introduction from '../pages/Introduction'
import Top from '../pages/Top'
import Flow from '../pages/Flow'
import PriceList from '../pages/PriceList'
import QA from '../pages/QA'
import CallToAction from '../pages/CallToAction'
import Architecture from '../pages/Architecture'
import { useRef } from 'react'
import useScrollHideContact from '../hooks/useScrollHideContact'
import MailmagazineLink from 'components/mailmagazine/MailmagazineLink/MailmagazineLink'
import NewsLp from '../pages/NewsLp'

const ContactFormId = '623d93e5-476c-4103-a708-0ce70c04e182'

const paths = [
  { name: 'TOP', url: '/' },
  { name: 'Services', url: '/services' },
  { name: 'CircleCI', url: '#' },
]

const TopContents = {
  smallTitle: '高速で柔軟なCI/CDを実現',
  title: ['CircleCIで開発サイクルを加速'],
  text: 'クラウドネイティブな高速実行環境で、ビルドとテストを並列化し、開発からデプロイまでをシームレスに自動化します。',
  imgLink: '/images/LP/LP202407/Logo/LogoCircleCI.png',
}

const IntroductionContents = {
  title: 'CI/CDの遅さがビジネスの成長を妨げていませんか？',
  list: [
    {
      text: ['ビルドやテストに時間がかかり、開発のスピードが落ちている'],
      icon: '/images/LP/LP202407/Icon/Introduction/BsHourglassSplit.svg',
    },
    {
      text: ['複雑な開発環境の設定と管理に多くのリソースを費やしている'],
      icon: '/images/LP/LP202407/Icon/Introduction/BsMenuButton.svg',
    },
    {
      text: ['スケーラビリティとセキュリティの両立が難しい'],
      icon: '/images/LP/LP202407/Icon/Introduction/BsPentagonHalf.svg',
    },
  ],
}
const BestPracticeContents = {
  heading: ['CircleCIで実現する、スピーディで信頼性の高い', 'ソフトウェアデリバリーを提供します'],
  text: [
    'CircleCI導入支援サービスは、効率的なCI/CDプロセスの構築を目指す企業に最適です。',
    'クラウドベースの柔軟な環境で、高速なビルド、並列テスト実行、自動デプロイを実現。開発サイクルを大幅に短縮し、製品の品質向上とリリース頻度の増加を可能にします。当社の専門家チームが、お客さまのニーズに合わせた最適なCircleCI環境の設計から運用までをトータルでサポートします。',
  ],
}

const ArchitectureContents = {
  title: 'CircleCI',
  imgLink: ['/images/LP/LP202407/Architectures/architecture-circleci.png'],
}

const FeaturesContents = {
  title: 'CircleCI',
  items: [
    {
      num: '01',
      itemTitle: '高速で柔軟なCI/CD環境の構築',
      description:
        'CircleCIの並列実行機能を最適化し、高速なビルドとテストを実現。プロジェクトの特性に合わせて柔軟なCI/CDパイプラインを設計し、開発サイクルを大幅に短縮します。',
      src: '/images/LP/LP202407/img/img07.jpeg',
    },
    {
      num: '02',
      itemTitle: 'セキュアな自動デプロイの実現',
      description:
        'CircleCIのセキュリティ機能を最大限に活用し、安全な自動デプロイ環境を構築。堅牢なデプロイプロセスを確立します。',
      src: '/images/LP/LP202407/img/img02.jpeg',
    },
    {
      num: '03',
      itemTitle: '継続的な最適化とサポート',
      description:
        '導入後も、継続的にサポート。パフォーマンス分析、ボトルネックの特定、最新のベストプラクティスの適用など、常に最適な状態を維持します。',
      src: '/images/LP/LP202407/img/img08.jpeg',
    },
  ],
}

const FlowContents = [
  {
    num: 1,
    title: '現状分析',
    description: 'お客さまの開発プロセスと課題を詳細に分析します。',
    src: '/images/LP/LP202407/Icon/BsBarChartLine.svg',
  },
  {
    num: 2,
    title: 'CI/CD戦略の策定',
    description: 'CircleCIを活用した最適なCI/CD戦略を立案します。',
    src: '/images/LP/LP202407/Icon/BsDiagram3.svg',
  },
  {
    num: 3,
    title: '環境構築とワークフロー設計',
    description: 'CircleCI環境を構築し、効率的なワークフローを設計・実装します。また、スムーズな運用をサポートします。',
    src: '/images/LP/LP202407/Icon/BsPersonCheck.svg',
  },
]

const FAQContents = [
  {
    num: 1,
    question: 'CircleCIは、どのような規模のプロジェクトに適していますか？',
    answer:
      'CircleCIは、スタートアップから大規模エンタープライズまで、あらゆる規模のプロジェクトに対応できます。プロジェクトの規模や要件に応じた最適な設定をサポートします。',
  },
  {
    num: 2,
    question: '既存のCI/CDツールからCircleCIへの移行は難しいですか？',
    answer:
      '当社の専門チームが、スムーズな移行をサポートします。CircleCIは多くの一般的なCI/CDタスクをサポートしており、既存の設定やスクリプトを活用しながら段階的に移行することが可能です。',
  },
  {
    num: 3,
    question: 'CircleCI導入により、具体的にどのような効果が期待できますか？',
    answer:
      '導入により、ビルド時間の短縮（多くの場合50%以上）、テスト実行の高速化、デプロイ頻度の増加、開発者の生産性向上などが期待できます。具体的な効果は、プロジェクトの特性によって異なりますが、多くの場合、開発サイクル全体の効率が大幅に向上します。',
  },
  {
    num: 4,
    question: 'CircleCIのコスト管理はどのように行われますか？',
    answer:
      'CircleCIは使用量に基づく従量課金制を採用しています。Aitriaは、お客さまの利用状況に応じた最適なプラン選択と、コスト最適化戦略を提案し、効率的な利用をサポートします。',
  },
  {
    num: 5,
    question: 'AitriaのCircleCI導入支援サービスの特徴は何ですか？',
    answer:
      '当社の特徴は、CircleCI認定の専門家による手厚いサポート、豊富な導入実績に基づく知見、お客さまのビジネスニーズに合わせたカスタマイズ能力です。また、導入後のトレーニングや継続的な最適化支援により、CircleCIの利点を最大限に活用できるよう支援します。',
  },
]

const inPocketList = [
  {
    image: '/images/inPocket/Circle CI/story_circleCI.png',
    title: 'AIで生成する物語-第3話：CircleCIは「コスパが良い」と知った件について',
    date: '2024.8.29',
    href: 'https://aitria.co.jp/in-pocket/11608',
  },
  {
    image: '/images/inPocket/Circle CI/knowledge_CircleCI.png',
    title: 'CircleCIとは？他のCI/CDツールとの比較から料金体系まで詳しく解説',
    date: '2024.8.28',
    href: 'https://aitria.co.jp/in-pocket/11601',
  },
  {
    image: '/images/inPocket/Circle CI/cicd_point.png',
    title: 'CI/CDとは？CI/CDツールを選ぶポイント7選＆ツール比較！',
    date: '2024.8.23',
    href: 'https://aitria.co.jp/in-pocket/11532',
  },
]

const topics = [
  {
    title:
      '特徴量エンジニアリングを使って生成AIによるUIデザインと画面レイアウトのアウトプットをコントロールする技術を開発',
    date: '2024年9月6日',
    src: '/pressrelease/3726',
  },
  {
    title: 'アート引越センターが提供する、AIが自動見積りをするアプリの開発支援をいたしました',
    date: '2024年5月21日',
    src: '/pressrelease/3369',
  },
  // { title: '', date: '', src: '' },
]

const CallToActionContents = {
  heading: ['プロジェクトの成功は、', '優れたCI/CDから始まります'],
}

const CircleCI: React.FC = () => {
  const contactRef = useRef<HTMLDivElement>(null)
  const contentsRef = useRef<HTMLDivElement>(null)

  useScrollHideContact(contactRef, contentsRef)
  return (
    <>
      <article className={styles.LPPage}>
        <div className={styles.contents} ref={contentsRef}>
          <Top contents={TopContents} paths={paths} />
          <Introduction contents={IntroductionContents} />
          <BestPractice contents={BestPracticeContents} />
          <Architecture contents={ArchitectureContents} />
          <Features contents={FeaturesContents} />
          <Flow contents={FlowContents} />
          <PriceList />
          <QA contents={FAQContents} />
          <NewsLp inPocketList={inPocketList} topics={topics} />
          <CallToAction contents={CallToActionContents} />
        </div>
        <div ref={contactRef} className={styles.contact_wrapper}>
          <Contact formId={ContactFormId} />
        </div>
        <div>
          <MailmagazineLink />
        </div>
      </article>
    </>
  )
}
export default CircleCI
